import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import UISelect from 'UIComponents/input/UISelect';
import { useUsersByScope } from '../hooks/useUsersByScope';
import { SUPER_ADMIN } from '../constants/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
function ApproverSelect(props) {
  const {
    value,
    onChange
  } = props;
  const {
    fetchUsers,
    users
  } = useUsersByScope(SUPER_ADMIN);
  useEffect(() => {
    fetchUsers();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const options = users.map(item => Object.assign({
    // text is not visible, only used for searching
    // dropdownText and buttonText is what the user sees
    text: `${item.firstName} ${item.lastName} ${item.email}`,
    dropdownText: /*#__PURE__*/_jsx(FormattedName, {
      givenName: item.firstName,
      familyName: item.lastName,
      email: item.email
    }),
    buttonText: /*#__PURE__*/_jsx(FormattedName, {
      givenName: item.firstName,
      familyName: item.lastName,
      email: item.email
    }),
    value: item.id,
    help: item.email
  }, item));
  const onChangeApprover = e => {
    const selected = users.find(item => item.id === Number(e.target.value));
    onChange(selected);
  };
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "ui-tool-access-approver-select",
    value: value ? value.id : null,
    onChange: onChangeApprover,
    options: options,
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "toolAccess.selectAdmin"
    })
  });
}
export default ApproverSelect;